import { Tooltip } from '@biq/apex-ui';
import InfoIcon from '@mui/icons-material/Info';
import { Icon, SxProps } from '@mui/material';
import React, { ReactNode } from 'react';
import { themeObject } from '../../lib';

interface InfoTooltipIconProps {
    title: string | ReactNode;
    popperStyles?: SxProps;
    modifiers?: [
        {
            name: string;
            options: {
                offset: [number, number];
            };
        },
    ];
}

const styles = {
    iconStyles: {
        '& .MuiSvgIcon-root': {
            height: '14px',
            width: '14px',
            mb: '3px',
            ml: '2px',
            color: themeObject.palette.primary[400],
        },
    },
};

export const InfoTooltipIcon = ({
    title,
    popperStyles,
    modifiers,
}: InfoTooltipIconProps): React.JSX.Element => {
    return (
        <Tooltip
            title={title}
            arrow
            placement={'top'}
            slotProps={{
                popper: {
                    sx: popperStyles,
                    modifiers: modifiers ?? [],
                },
            }}
        >
            <Icon fontSize='inherit' color='primary' sx={styles.iconStyles}>
                <InfoIcon />
            </Icon>
        </Tooltip>
    );
};
